import React from 'react'
import { H2, P } from '../StyledText'
import { DangerButton } from '../DangerButton'
import { StyledSettingDeleteArea } from './styled'

interface ISettingDeleteArea {
  onClickHandler: any
  texts: {
    title: string
    description: string
    buttonLabel: string
  }
  buttonProps?: {
    id?: string
  }
  disabled?: boolean
}

// TODO: Move modals there
export const SettingDeleteArea = ({
  onClickHandler,
  buttonProps,
  texts,
  disabled = false,
}: ISettingDeleteArea) => (
  <StyledSettingDeleteArea>
    <H2 mb="true">{texts.title}</H2>
    <P>{texts.description}</P>
    <div className="button-wrapper">
      <DangerButton
        {...buttonProps}
        variant="outlined"
        onClick={onClickHandler}
        disabled={disabled}
      >
        {texts.buttonLabel}
      </DangerButton>
    </div>
  </StyledSettingDeleteArea>
)
